import { Component, Injectable, Input, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Projeto } from '../../models/projeto.model';
import { RequestsService } from '../../services/requests.service';
import {ModalConfig} from '../modal/modal.component';

@Component({
  selector: 'modalclone',
  templateUrl: './modalclone.component.html',
  styleUrls: ['./modalclone.component.css']
})
@Injectable({
  providedIn: 'root',
})

export class ModalcloneComponent implements OnInit {
  @Input() public modalConfig: ModalConfig;
  @ViewChild('modalclone') private modalcloneContent: TemplateRef<ModalcloneComponent>
  private modalcloneRef: NgbModalRef
  constructor(private modalService: NgbModal, private requestService: RequestsService) { }
  public projetos: Projeto[];
  idProjeto: number;
  isConfirmed: boolean = false;

  ngOnInit(): void {}

  open(id): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.modalcloneRef = this.modalService.open(this.modalcloneContent, { size: '' })
      this.modalcloneRef.result.then(resolve, resolve)
      this.requestService.listOutrosProjetos(id).subscribe(x => {
        this.projetos = x;
      });
    })
  }

  async close(): Promise<void> {
    if (this.modalConfig.shouldClose === undefined || (await this.modalConfig.shouldClose())) {
      const result = this.modalConfig.onClose === undefined || (await this.modalConfig.onClose())
      this.modalcloneRef.close(result)
    }
  }

  async dismiss(): Promise<void> {
    if (this.modalConfig.shouldDismiss === undefined || (await this.modalConfig.shouldDismiss())) {
      const result = this.modalConfig.onDismiss === undefined || (await this.modalConfig.onDismiss())
      this.modalcloneRef.dismiss(result)
    }
  }

  continue(confirmation): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      resolve(confirmation)
    })
  }

  accept() {
    this.isConfirmed = true;
    this.close();
  }

}

